module.exports = __webpack_public_path__ + "img/icon_to.29bcc597.svg";